import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API}/whitebooks-authenticate`;

export const getPublicIp = async () => {
    return "172.0.0.1";
};

export const EwayBillTokenGenerator = () => {
    const generateToken = async () => {
        try {
            const response = await axios.get(API_URL);

            if (response.data && response.status === 200) {
                return response.data;
            } else {
                console.error("Failed to fetch token:", response);
                return null;
            }
        } catch (error) {
            console.error("Error during token generation:", error);
            return null;
        }
    };

    return { generateToken };
};

export default EwayBillTokenGenerator;
